<template>
<div class="chapter">
<div class="inner_page">
<section aria-labelledby="headeracknow01" class="chapter" epub:type="acknowledgments" id="acknow" role="doc-acknowledgments">
<header id="headeracknow01">
<h1 class="ctfm"><span aria-label=" Page vi. " class="page" epub:type="pagebreak" id="pvi" role="doc-pagebreak"></span><span aria-label=" Page vii. " class="page" epub:type="pagebreak" id="pvii" role="doc-pagebreak"></span><a class="xref" href="#/wsutvmsciencefiction0007#racknow">Acknowledgments</a></h1>
</header>
<p class="pf"><span class="dropcap">T</span>wenty years ago I had the opportunity to lead off Wayne State University’s new TV Milestones series with my volume <i>Disney TV</i>. I want to thank the press, and especially series editor Barry Grant and senior acquisitions editor Marie Sweetman, for being receptive to and indeed encouraging the idea of my authoring a second TV Milestones book. Let me also express my appreciation for copy editor Jude Grant’s deft touch, which has made the book a more pleasing read. Providing valuable assistance to my research were the staff members at the Wisconsin Center for Film and Theater Research, particularly Mary Huelsbeck and Lisa Marine. Finally, I need to thank my wife, Leigh Ehlers Telotte, for her support and advice throughout the writing and production process. This book is dedicated to her.</p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// wsu-tvmsciencefiction-0008.vue?21fe0c5e